import UserInvite from './UserInvite';
import UserInviteSkelet from './UserInviteSkelet';

export { UserInviteSkelet };
export default UserInvite;
